export enum TipoAcessorio {
  TIPO_ACESSORIO_ENTRADA_DIGITAL = 1,
  TIPO_ACESSORIO_SAIDA_DIGITAL   = 2,
  TIPO_ACESSORIO_TEMPERATURA     = 3,
  TIPO_ACESSORIO_UMIDADE         = 4,
  TIPO_ACESSORIO_TENSAO          = 5,
  TIPO_ACESSORIO_ANALOGICO       = 6,
  TIPO_ACESSORIO_INDEFINIDO      = 65535,
}

export const ACCESSORY_TYPE_LABELS: Record<number, string> = {
  [TipoAcessorio.TIPO_ACESSORIO_ENTRADA_DIGITAL]: 'Entrada Digital',
  [TipoAcessorio.TIPO_ACESSORIO_SAIDA_DIGITAL]:   'Saída Digital',
  [TipoAcessorio.TIPO_ACESSORIO_TEMPERATURA]:     'Temperatura',
  [TipoAcessorio.TIPO_ACESSORIO_UMIDADE]:         'Umidade',
  [TipoAcessorio.TIPO_ACESSORIO_TENSAO]:          'Tensão',
  [TipoAcessorio.TIPO_ACESSORIO_ANALOGICO]:       'Analógico',
  [TipoAcessorio.TIPO_ACESSORIO_INDEFINIDO]:      'Indefinido',
};

export const ACCESSORY_TYPE_LABEL_KEYS: Record<number, string> = {
  [TipoAcessorio.TIPO_ACESSORIO_ENTRADA_DIGITAL]: 'accessory.type.inputDigital',
  [TipoAcessorio.TIPO_ACESSORIO_SAIDA_DIGITAL]:   'accessory.type.outputDigital',
  [TipoAcessorio.TIPO_ACESSORIO_TEMPERATURA]:     'accessory.type.temperature',
  [TipoAcessorio.TIPO_ACESSORIO_UMIDADE]:         'accessory.type.humidity',
  [TipoAcessorio.TIPO_ACESSORIO_TENSAO]:          'accessory.type.voltage',
  [TipoAcessorio.TIPO_ACESSORIO_ANALOGICO]:       'accessory.type.analog',
  [TipoAcessorio.TIPO_ACESSORIO_INDEFINIDO]:      'accessory.type.undefined',
};

export function getAccessoryTypeLabel(
  value: number,
  translate?: (key: string) => string,
): string {
  const decodedType = decodeTipoAcessorio(value);
  const fallback = ACCESSORY_TYPE_LABELS[decodedType] ?? ACCESSORY_TYPE_LABELS[TipoAcessorio.TIPO_ACESSORIO_INDEFINIDO];

  if (!translate) {
    return fallback;
  }

  const key = ACCESSORY_TYPE_LABEL_KEYS[decodedType];
  const translated = translate(key);
  return translated && translated !== key ? translated : fallback;
}

export function decodeTipoAcessorio(value: number): TipoAcessorio {
  if (Object.values(TipoAcessorio).includes(value as TipoAcessorio)) {
    return value as TipoAcessorio;
  }
  return TipoAcessorio.TIPO_ACESSORIO_INDEFINIDO;
}

export function kindToTipoAcessorio(kindOrType: string | number | undefined | null): TipoAcessorio {
  if (typeof kindOrType === 'number') {
    return decodeTipoAcessorio(kindOrType);
  }
  const k = (kindOrType ?? '').toString().toLowerCase()
    .normalize('NFD').replaceAll(/[\u0300-\u036f]/g, '');
  if (k.includes('temperatura') || k.includes('temperature')) {
    return TipoAcessorio.TIPO_ACESSORIO_TEMPERATURA;
  }
  if (k.includes('umidade') || k.includes('humidity')) {
    return TipoAcessorio.TIPO_ACESSORIO_UMIDADE;
  }
  if (k.includes('tensao') || k.includes('voltage')) {
    return TipoAcessorio.TIPO_ACESSORIO_TENSAO;
  }
  if (k.includes('analogico') || k.includes('analog')) {
    return TipoAcessorio.TIPO_ACESSORIO_ANALOGICO;
  }
  if (k.includes('atuador') || k.includes('actuator') || k.includes('saida') || k.includes('output')) {
    return TipoAcessorio.TIPO_ACESSORIO_SAIDA_DIGITAL;
  }
  return TipoAcessorio.TIPO_ACESSORIO_ENTRADA_DIGITAL;
}
